module.exports = __webpack_public_path__ + "img/8.1e0e4a52.jpg";